/* Hafif Japon estetiği — saf SVG/CSS, sıfır raster, pointer-events kapalı dekorlar.
   Palet değişmez: blush/aqua/brand tonlarının düşük opaklıklı halleri kullanılır. */

export function JapanMascot({ className = "w-20" }) {
  return <img src="/img/intro/japan-cells.png" alt="" aria-hidden="true" className={`object-contain ${className}`} />;
}

/* Hafif Japon estetiği — saf SVG/CSS, sıfır raster, pointer-events kapalı dekorlar.
   Palet değişmez: blush/aqua/brand tonlarının düşük opaklıklı halleri kullanılır. */

export function EnsoCircle({ className = "" }) {
  return (
    <svg viewBox="0 0 200 200" fill="none" className={className} aria-hidden="true">
      <circle cx="100" cy="100" r="82" stroke="currentColor" strokeWidth="14" strokeLinecap="round"
        strokeDasharray="470 60" transform="rotate(-38 100 100)" opacity="0.9" />
      <circle cx="100" cy="100" r="82" stroke="currentColor" strokeWidth="5" strokeLinecap="round"
        strokeDasharray="18 512" transform="rotate(120 100 100)" opacity="0.5" />
    </svg>
  );
}

function Blossom({ x, y, s = 1 }) {
  const petals = [0, 72, 144, 216, 288];
  return (
    <g transform={`translate(${x} ${y}) scale(${s})`}>
      {petals.map((a) => (
        <ellipse key={a} cx="0" cy="-7" rx="4.6" ry="7.5" fill="#F4D7DC" stroke="#E7A9BC" strokeWidth="0.8"
          transform={`rotate(${a})`} />
      ))}
      <circle r="2.2" fill="#E7A9BC" />
    </g>
  );
}

export function SakuraBranch({ className = "" }) {
  return (
    <svg viewBox="0 0 260 200" fill="none" className={className} aria-hidden="true">
      <path d="M255 6 C 205 30 168 58 138 96 C 118 122 96 142 62 156" stroke="#B98F8F" strokeWidth="3.5" strokeLinecap="round" />
      <path d="M196 42 C 184 60 182 76 188 92" stroke="#B98F8F" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M150 82 C 138 92 128 96 112 96" stroke="#B98F8F" strokeWidth="2.2" strokeLinecap="round" />
      <Blossom x={250} y={10} s={1.15} />
      <Blossom x={206} y={36} s={0.95} />
      <Blossom x={188} y={88} s={1.05} />
      <Blossom x={146} y={90} s={0.9} />
      <Blossom x={110} y={98} s={0.8} />
      <Blossom x={72} y={150} s={1} />
      <Blossom x={150} y={122} s={0.7} />
    </svg>
  );
}

export function FloatingPetals({ count = 9 }) {
  const petals = Array.from({ length: count }, (_, i) => {
    const left = (i * 97 + 13) % 100;
    const size = 10 + ((i * 7) % 9);
    const dur = 11 + ((i * 13) % 9);
    const delay = -((i * 3.7) % 14);
    const sway = (i % 2 === 0 ? 1 : -1) * (30 + ((i * 11) % 50));
    return { left, size, dur, delay, sway, key: i };
  });
  return (
    <>
      {petals.map((p) => (
        <svg key={p.key} viewBox="0 0 20 20" className="jp-petal"
          style={{ left: `${p.left}%`, width: p.size, animationDuration: `${p.dur}s`, animationDelay: `${p.delay}s`, "--sway": `${p.sway}px` }}
          aria-hidden="true">
          <path d="M10 1 C 15 6 16 12 10 19 C 4 12 5 6 10 1 Z" fill="#F4D7DC" stroke="#E7A9BC" strokeWidth="0.7" />
        </svg>
      ))}
    </>
  );
}

export function SeigaihaStrip({ className = "" }) {
  return (
    <svg viewBox="0 0 120 30" preserveAspectRatio="none" className={className} aria-hidden="true">
      <defs>
        <pattern id="seigaiha" width="30" height="15" patternUnits="userSpaceOnUse">
          <g fill="none" stroke="#A0D3E8" strokeWidth="1">
            <circle cx="15" cy="15" r="14" />
            <circle cx="15" cy="15" r="10" />
            <circle cx="15" cy="15" r="6" />
            <circle cx="0" cy="15" r="14" />
            <circle cx="30" cy="15" r="14" />
            <circle cx="0" cy="15" r="10" />
            <circle cx="30" cy="15" r="10" />
          </g>
        </pattern>
      </defs>
      <rect width="120" height="30" fill="url(#seigaiha)" />
    </svg>
  );
}

export function FujiSilhouette({ className = "" }) {
  return (
    <svg viewBox="0 0 400 90" preserveAspectRatio="xMidYMax meet" className={className} aria-hidden="true">
      <path d="M20 90 C 90 58 150 34 178 14 L 192 4 L 206 14 C 234 34 300 58 380 90 Z" fill="currentColor" opacity="0.55" />
      <path d="M170 22 L 192 4 L 214 22 C 208 26 204 24 200 28 C 196 24 192 26 188 22 C 184 26 176 26 170 22 Z" fill="#F0F6FA" opacity="0.85" />
    </svg>
  );
}

export function VerticalKanji({ text, className = "" }) {
  return (
    <span className={`jp-vertical select-none font-heading ${className}`} aria-hidden="true">{text}</span>
  );
}

/* Büyük arka plan kanji filigranı — bölümlerin boşluklarına zarif Japonca imza */
export function KanjiWatermark({ text, className = "", light = false }) {
  return (
    <span aria-hidden="true"
      className={`absolute select-none pointer-events-none font-heading font-bold leading-none ${light ? "text-white/[0.06]" : "text-ink/[0.05]"} ${className}`}>
      {text}
    </span>
  );
}

/* Aralık ayında kapıda hafif kar yağışı */
export function Snowfall({ count = 40 }) {
  const flakes = Array.from({ length: count }, (_, i) => {
    const left = (i * 61 + 7) % 100;
    const size = 3 + ((i * 5) % 4);
    const dur = 8 + ((i * 17) % 10);
    const delay = -((i * 2.9) % 12);
    const sway = (i % 2 === 0 ? 1 : -1) * (14 + ((i * 13) % 30));
    const op = 0.5 + ((i * 7) % 40) / 100;
    return { left, size, dur, delay, sway, op, key: i };
  });
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {flakes.map((f) => (
        <span key={f.key} className="jp-snow"
          style={{ left: `${f.left}%`, width: f.size, height: f.size, opacity: f.op,
            animationDuration: `${f.dur}s`, animationDelay: `${f.delay}s`, "--sway": `${f.sway}px` }} />
      ))}
    </div>
  );
}
